import { Form, useField } from 'vee-validate';
import { schema } from './schema';
import { initialValues } from './initialValues';
import { scrollToTop } from '../../helpers/scrollToTop';
import PatientData from '../shared/PatientData.vue';
import EmailRegisterField from '../shared/Fields/RegisterFields/EmailRegisterField.vue';
import Password from '../shared/Fields/RegisterFields/Password.vue';
import ConfirmPassword from '../shared/Fields/RegisterFields/ConfirmPassword.vue';
import AcceptRegistrationTerms from '../shared/Fields/RegisterFields/AcceptRegistrationTerms.vue';
import { useOnSubmit } from './hooks/useOnSubmit';


export default {
  __name: 'PatientRegistration',
  setup(__props, { expose }) {
  expose();

const { isSubmitting, onSubmit, status, registeredEmail, responseMessage } = useOnSubmit();

const url = jsData.siteUrl;

const __returned__ = { isSubmitting, onSubmit, status, registeredEmail, responseMessage, url, get Form() { return Form }, get useField() { return useField }, get schema() { return schema }, get initialValues() { return initialValues }, get scrollToTop() { return scrollToTop }, PatientData, EmailRegisterField, Password, ConfirmPassword, AcceptRegistrationTerms, get useOnSubmit() { return useOnSubmit } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}